import React, { useState } from "react";
import axios from "axios";
import { BASE_API_URL } from "../../constant";
import OtpInput from 'react-otp-input';
import { useNavigate } from "react-router-dom";

function AddWinningNumber() {

    const Navigate = useNavigate();

    const [winningNumber, setWinningNumber] = useState("");

    const handleAddWN = async (e) => {
        e.preventDefault();
        if (winningNumber === "") {
            alert("Please enter a number");
            return;
        }

        await axios.post(BASE_API_URL + "api/winning/winning_number", {
            winningNumber
        }).then((res) => {
            console.log(res.data);
            Navigate("/admin/dashboard");
            alert("Winning Number Added Successfully");
        }).catch((err) => {
            console.log(err);
            alert("Something went wrong");
        }
        );

    };

    return (
        <div className="d-flex justify-content-center align-items-cemter bg-secondary vh-100">
            <div className="bg-white p-3 rounded w-40">
                <h2 className="text-center">Add Today's Winning Number</h2>
                <form onSubmit={handleAddWN}>
                    <div className="form-group mb-3 d-flex">
                        <label htmlFor="winningNumber">Enter Winning Number</label>
                        <div className="d-flex justify-content-center">
                            <OtpInput
                                value={winningNumber}
                                onChange={setWinningNumber}
                                numInputs={5}
                                shouldAutoFocus={true}
                                inputStyle={{ width: "50px", height: "50px", }}
                                renderInput={(props) => <input {...props} type="number" />}
                            />
                        </div>
                    </div>

                    <button type="submit" className="btn btn-success w-100 rounded-0">Add</button>
                </form>
            </div>
        </div>
    )
}

export default AddWinningNumber;